export default __webpack_public_path__ + "static/media/ic_checkout.56fb9be8.png";